export const splitString = (
  input: unknown,
  emptyResult: string[] | null = null,
): string[] | null => {
  if (typeof input !== 'string') return emptyResult;

  const items = input
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);

  return items.length ? items : emptyResult;
};
